import React, { useEffect, useState } from 'react';
import './AnimatedList.css';

interface IData {
    name: string, id: string
}

export const AnimatedList = ({dataList}:{dataList: IData[]})=>{
    const [animatedDataList, setAnimatedDataList] = useState<{data: IData, state: string}[]>([]);
    console.log(dataList, animatedDataList);
    useEffect(()=>{
        setAnimatedDataList(last=>{
            const lastMap: Record<string, {data: IData, state: string}>={};
            last.forEach((it, i)=>{
                lastMap[it.data.id] = it;
            })
            const dataMap: Record<string, IData>={};
            dataList.forEach((it, i)=>{
                dataMap[it.id] = it;
            })
            const nextMap: Record<string, {data: IData, state: string}> = {};
            dataList.forEach((it, i)=>{
                const lastItem = lastMap[it.id];
                if (lastItem){
                    nextMap[it.id] = lastItem;
                } else {
                    nextMap[it.id] = {data: it, state: 'create'};
                }
            });
            last.forEach(it=>{
                const dataItem = dataMap[it.data.id];
                if (!dataItem && lastMap[it.data.id].state !='deleted'){
                    nextMap[it.data.id] = {data: it.data, state: 'delete'};
                }
            });
            return Object.values(nextMap).sort((a, b)=> (Number(a.data.id < b.data.id) -0.5) *2 );
        });
    }, [dataList]);

    return <div className='AnimatedList'>
        {animatedDataList.map(dataItem=>{
            return <div key={dataItem.data.id} onAnimationEnd={()=>{
                setAnimatedDataList((last)=>{
                    return last.map(it=>it.data.id == dataItem.data.id ? {...dataItem, state: {'create': '', 'delete': 'deleted', '': '', 'deleted':'deleted'}[dataItem.state || ''] || ''} : it).filter(it=>it.state!='deleted');
                })
            }} className={`AnimatedList_item AnimatedList_item--${dataItem.state}`}>
                {dataItem.data.name}
            </div>
        })}
    </div>
}